// Per-session runtime state: pointer/key flags, frame-loop handle, disposers.
// These are mutated by input/, render/loop, and selection-interaction wiring;
// none of it survives a reload.

export interface InputState {
    keys: Record<string, boolean>;
    helpOutsideClose: boolean;
    isDragging: boolean;
    isResizing: boolean;
    dragStartPos: { x: number; y: number } | null;
    initialMousePos: { x: number; y: number } | null;
    mouseOverCube: boolean;
}

export interface LoopHandle {
    onResize: () => void;
}

export interface LoopState {
    handle: LoopHandle | null;
}

export interface DisposeState {
    keyboard: (() => void) | null;
    selectionInteractions: (() => void) | null;
    /** Gnomon disposer; stored (not just pushed into UI offs) so a camera
     *  projection swap can dispose + reinstall it against the new camera. */
    cameraGnomon: (() => void) | null;
    /** Fly-mode drag-to-look pointer handler disposer. */
    flyLook: (() => void) | null;
    /** Help-panel + tabs DOM wiring disposer (see src/ui/events.ts). */
    domEvents: (() => void) | null;
}

export function createInputState(): InputState {
    return {
        keys: {},
        helpOutsideClose: false,
        isDragging: false,
        isResizing: false,
        dragStartPos: null,
        initialMousePos: null,
        mouseOverCube: false,
    };
}

export function createLoopState(): LoopState {
    return {
        handle: null,
    };
}

export function createDisposeState(): DisposeState {
    return {
        keyboard: null,
        selectionInteractions: null,
        cameraGnomon: null,
        flyLook: null,
        domEvents: null,
    };
}
